import script from "./StaffNotificationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./StaffNotificationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./StaffNotificationDialog.vue?vue&type=style&index=0&id=118cf022&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-118cf022"]])

export default __exports__